/**
 * 판매자 센터를 주소창으로 열었을 때 — 이 앱은 씨마켓 로그인(임베드 토큰)으로만 열린다.
 * 예전엔 «Embed Only Mode» 한 줄만 보였다. 공급기업이 길을 잃지 않게 로그인·가입 길을 보여 준다(가입 경로 ref=vendor).
 */
import { CMARKET_LOGIN_URL, mainSiteOrigin } from "./mainSite";

export function VendorEntryFallback() {
  const origin = mainSiteOrigin(window.location);
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-canvas px-4">
      <div
        className="flex w-full max-w-md flex-col gap-4 rounded-2xl bg-white p-6"
        data-testid="vendor-entry-fallback"
      >
        <h1 className="text-lg font-bold text-gray-900">세모 판매자 센터</h1>
        <p className="text-sm text-gray-600">
          판매자 센터는 씨마켓 아이디로 로그인해서 들어와요. 아직 가입하지 않은
          공급기업이면 세모에서 한 번에 가입할 수 있어요(씨마켓도 같은 아이디).
        </p>
        <a
          href={CMARKET_LOGIN_URL}
          className="rounded-xl bg-[#6b3ad5] px-4 py-3 text-center text-sm font-semibold text-white"
          data-testid="vendor-entry-login"
        >
          씨마켓 아이디로 로그인
        </a>
        <a
          href={`${origin}/join/supplier?ref=vendor`}
          className="rounded-xl border border-[#6b3ad5] px-4 py-3 text-center text-sm font-semibold text-[#6b3ad5]"
          data-testid="vendor-entry-join"
        >
          공급기업 가입하기
        </a>
        <p className="text-xs text-gray-400">
          가입비 55,000원(부가세 포함) · 6개월 무료, 이후 월 3,300원
        </p>
      </div>
    </div>
  );
}
